import { createSelector } from 'reselect';
import { appAIAlertFeatureFlagSelector } from '@store/common/selectors';

export const appAIAlertEnabledSelector = createSelector(
  (state) => appAIAlertFeatureFlagSelector(state),
  (appAIAlert) => {
    return appAIAlert;
  },
);
